const getStep = (id, section, subSectionId, subSectionStep) => {
  let subSection;
  if (subSectionId) {
    subSection = section.items.find((section) => section.id === subSectionId);
  }
  if (subSection) {
    // console.log("subSection", subSection);
    return `${subSectionStep}.${Array.from(subSection.steps).indexOf(id) + 1}`;
  }
  return Array.from(section.steps).indexOf(id) + 1;
};

// const attributes = {
//   id: "hEB9Zvbz3sJ_zDMU7aS-z",
//   title: "Test Procedure 2",
//   notes: "N/A",
//   revision: "Rev-1",
//   status: "COMPLETED",
//   description: "N/A",
//   create_date: "2022-09-02T14:52:25.707Z",
//   update_date: "2022-09-02T14:52:25.707Z",
//   items: [
//     {
//       id: "MToJtYIWS6RKN9M7-PLcK",
//       type: "SECTION",
//       items: [
//         {
//           id: "0r0hmqZBT8ZGZCtlWuPVu",
//           type: "INSTRUCTION",
//           title: "",
//           content:
//             "Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more.",
//           infoPanel: "none",
//           section_id: "MToJtYIWS6RKN9M7-PLcK",
//         },
//         {
//           id: "D18fxr39iDiYIzbOanmyS",
//           type: "INSTRUCTION",
//           title: "",
//           content:
//             "Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more.",
//           infoPanel: "Information",
//           section_id: "MToJtYIWS6RKN9M7-PLcK",
//         },
//         {
//           id: "nRTPm3lqycAKMM5-LfEWx",
//           type: "INSTRUCTION",
//           title: "",
//           content:
//             "Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more.",
//           infoPanel: "Warning",
//           section_id: "MToJtYIWS6RKN9M7-PLcK",
//         },
//         {
//           id: "hvi6e08PturHHb3yy0GoG",
//           type: "INSTRUCTION",
//           title: "",
//           content:
//             "Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more.",
//           infoPanel: "none",
//           section_id: "MToJtYIWS6RKN9M7-PLcK",
//         },
//       ],
//       steps: [
//         "0r0hmqZBT8ZGZCtlWuPVu",
//         "D18fxr39iDiYIzbOanmyS",
//         "nRTPm3lqycAKMM5-LfEWx",
//         "hvi6e08PturHHb3yy0GoG",
//       ],
//       title: "Section Title One",
//     },
//     {
//       id: "ruovLgOuaxknyH029Qg4_",
//       type: "SECTION",
//       items: [
//         {
//           id: "bBD3ccnue3-8OtcqcCnnK",
//           type: "GROUP",
//           items: [
//             {
//               id: "nTXAtqgPCTjfVevcfjI2o",
//               na: true,
//               skip: false,
//               type: "YES/NO",
//               warn: false,
//               label: "Battery Test",
//               _group: "bBD3ccnue3-8OtcqcCnnK",
//               section_id: "ruovLgOuaxknyH029Qg4_",
//               test_types: "AFFIRMATIVE_PASS",
//               description: "Is the battery fully charged?",
//             },
//             {
//               id: "of9_bRfslSMTvLjd-pbUL",
//               na: false,
//               skip: false,
//               type: "PASS/FAIL",
//               warn: false,
//               label: "Self Test",
//               _group: "bBD3ccnue3-8OtcqcCnnK",
//               section_id: "ruovLgOuaxknyH029Qg4_",
//               description: "Initiate Instrument Self test and record result",
//             },
//           ],
//           section_id: "ruovLgOuaxknyH029Qg4_",
//         },
//         {
//           id: "-QT5QJai8JpIyOgCVoesr",
//           type: "INSTRUCTION",
//           title: "",
//           content:
//             "Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more.",
//           infoPanel: "none",
//           section_id: "ruovLgOuaxknyH029Qg4_",
//         },
//         {
//           id: "AoZXHmmoMHQPhpexlFFdH",
//           type: "INSTRUCTION",
//           title: "",
//           content:
//             "Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more.",
//           infoPanel: "none",
//           section_id: "ruovLgOuaxknyH029Qg4_",
//         },
//         {
//           id: "K9V8Q5m056ggeK4imNg3s",
//           type: "GROUP",
//           items: [
//             {
//               id: "u2K-tKskNynCUKag48XtK",
//               na: true,
//               skip: false,
//               type: "YES/NO",
//               warn: false,
//               label: "Battery Test",
//               _group: "K9V8Q5m056ggeK4imNg3s",
//               section_id: "ruovLgOuaxknyH029Qg4_",
//               test_types: "AFFIRMATIVE_FAIL",
//               description: "Is the low battery indicator on?",
//             },
//             {
//               id: "LLQg8vaBAeTPh96WK_ptV",
//               na: true,
//               skip: false,
//               type: "PASS/FAIL",
//               warn: false,
//               label: "Self Test",
//               _group: "K9V8Q5m056ggeK4imNg3s",
//               section_id: "ruovLgOuaxknyH029Qg4_",
//               description: "Initiate Instrument Self test and record result",
//             },
//             {
//               id: "887rWbqkkIaEvYHtOrNq3",
//               na: true,
//               skip: false,
//               type: "TASK ITEM",
//               warn: false,
//               label: "Cleaning",
//               _group: "K9V8Q5m056ggeK4imNg3s",
//               repeat: 1,
//               section_id: "ruovLgOuaxknyH029Qg4_",
//               description: "Clean the instrument",
//               checkbox_label: "Completed",
//             },
//             {
//               id: "DAH0t7gucNeL0CgUB4Ghb",
//               na: false,
//               skip: false,
//               type: "TASK ITEM",
//               warn: false,
//               label: "Excercise",
//               _group: "K9V8Q5m056ggeK4imNg3s",
//               repeat: "4",
//               section_id: "ruovLgOuaxknyH029Qg4_",
//               description: "Exercise 4 times",
//               checkbox_label: "Completed",
//             },
//             {
//               id: "ILy5wLminwFkEgSGoALeQ",
//               na: false,
//               skip: false,
//               type: "PASS/FAIL",
//               warn: false,
//               label: "Test 1234",
//               _group: "K9V8Q5m056ggeK4imNg3s",
//               section_id: "ruovLgOuaxknyH029Qg4_",
//               description: "N/A",
//             },
//           ],
//           section_id: "ruovLgOuaxknyH029Qg4_",
//         },
//       ],
//       steps: [
//         "nTXAtqgPCTjfVevcfjI2o",
//         "of9_bRfslSMTvLjd-pbUL",
//         "-QT5QJai8JpIyOgCVoesr",
//         "AoZXHmmoMHQPhpexlFFdH",
//         "u2K-tKskNynCUKag48XtK",
//         "LLQg8vaBAeTPh96WK_ptV",
//         "887rWbqkkIaEvYHtOrNq3",
//         "DAH0t7gucNeL0CgUB4Ghb",
//         "ILy5wLminwFkEgSGoALeQ",
//       ],
//       title: "Section Title Two",
//     },
//     {
//       id: "mSY5yEAm60oC9zM_O43CS",
//       type: "SECTION",
//       items: [
//         {
//           id: "SWbf0Pz5qacnrX0CaaCJD",
//           type: "GROUP",
//           items: [
//             {
//               id: "P_jFotoqqpI7SvG6NKJeJ",
//               na: false,
//               url: "http://localhost:3001/",
//               skip: false,
//               type: "CUSTOM",
//               warn: false,
//               label: "TI Analysis",
//               _group: "SWbf0Pz5qacnrX0CaaCJD",
//               section_id: "mSY5yEAm60oC9zM_O43CS",
//               description: "N/A",
//               configuration: "",
//             },
//           ],
//           section_id: "mSY5yEAm60oC9zM_O43CS",
//         },
//       ],
//       steps: ["P_jFotoqqpI7SvG6NKJeJ"],
//       title: "Section Title Three",
//     },
//     {
//       id: "JuYhS5weVhSEtiyFclPNk",
//       type: "SECTION",
//       items: [
//         {
//           id: "QN7GXnr_0j2SyyFpRbTZd",
//           type: "GROUP",
//           items: [
//             {
//               id: "LnjMrnxqp47pJBEvO45mn",
//               na: false,
//               skip: false,
//               type: "PASS/FAIL",
//               warn: false,
//               label: "Test",
//               _group: "QN7GXnr_0j2SyyFpRbTZd",
//               section_id: "JuYhS5weVhSEtiyFclPNk",
//               description: "Test",
//             },
//           ],
//           section_id: "JuYhS5weVhSEtiyFclPNk",
//         },
//         {
//           id: "J6CVkGW7V4AEOgewgsIus",
//           type: "SUB-SECTION",
//           items: [
//             {
//               id: "izY0Uk175Nn_agEsHLl5w",
//               type: "GROUP",
//               items: [
//                 {
//                   id: "klHyp7Lgp-VZszpRF1_k8",
//                   na: false,
//                   skip: false,
//                   type: "PASS/FAIL",
//                   warn: false,
//                   label: "Test",
//                   _group: "izY0Uk175Nn_agEsHLl5w",
//                   section_id: "JuYhS5weVhSEtiyFclPNk",
//                   description: "Test",
//                 },
//               ],
//               section_id: "JuYhS5weVhSEtiyFclPNk",
//             },
//           ],
//           steps: ["klHyp7Lgp-VZszpRF1_k8"],
//           title: "Sub Section One",
//           section_id: "JuYhS5weVhSEtiyFclPNk",
//         },
//         {
//           id: "Tjc_ttmfwIBdZPrXjrIjq",
//           type: "GROUP",
//           items: [
//             {
//               id: "g-faH7hlg6oYz2rwjKr8l",
//               na: false,
//               skip: false,
//               type: "YES/NO",
//               warn: false,
//               label: "Test Component1",
//               _group: "Tjc_ttmfwIBdZPrXjrIjq",
//               section_id: "JuYhS5weVhSEtiyFclPNk",
//               test_types: "AFFIRMATIVE_PASS",
//               description: "N/A",
//             },
//             {
//               id: "e5HY-nJhGJRRqxW-w5oou",
//               na: false,
//               skip: false,
//               type: "PASS/FAIL",
//               warn: true,
//               label: "Test Component2",
//               _group: "Tjc_ttmfwIBdZPrXjrIjq",
//               section_id: "JuYhS5weVhSEtiyFclPNk",
//               description: "Test Component",
//             },
//             {
//               id: "np9-J0il747pHeXalMloz",
//               na: false,
//               skip: false,
//               type: "TASK ITEM",
//               warn: true,
//               label: "Test Component3",
//               _group: "Tjc_ttmfwIBdZPrXjrIjq",
//               repeat: "10",
//               section_id: "JuYhS5weVhSEtiyFclPNk",
//               description: "N/A",
//               checkbox_label: "Completed",
//             },
//             {
//               id: "Ph5S2um3tV9iX36QqCqaZ",
//               na: false,
//               skip: false,
//               type: "YES/NO",
//               warn: false,
//               label: "Test Component4",
//               _group: "Tjc_ttmfwIBdZPrXjrIjq",
//               section_id: "JuYhS5weVhSEtiyFclPNk",
//               test_types: "AFFIRMATIVE_PASS",
//               description: "N/A",
//             },
//             {
//               id: "DQwTwO0sFtp34-EozEjTY",
//               na: false,
//               url: "https://www.cubyt.io/about",
//               skip: false,
//               type: "CUSTOM",
//               warn: false,
//               label: "Cubyt About US",
//               _group: "Tjc_ttmfwIBdZPrXjrIjq",
//               section_id: "JuYhS5weVhSEtiyFclPNk",
//               description: "N/A",
//               configuration: "",
//             },
//           ],
//           section_id: "JuYhS5weVhSEtiyFclPNk",
//         },
//         {
//           id: "4VVd_nlYvXBIGuNI-TLsS",
//           type: "INSTRUCTION",
//           title: "",
//           content:
//             "Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more.",
//           infoPanel: "Information",
//           section_id: "JuYhS5weVhSEtiyFclPNk",
//         },
//         {
//           id: "iFjLUIV1Z0qyg_MTu8wVL",
//           type: "GROUP",
//           items: [
//             {
//               id: "oNy3aMym_ORgjqe4f6PHI",
//               na: false,
//               skip: false,
//               type: "YES/NO",
//               warn: false,
//               label: "Test Component4",
//               _group: "iFjLUIV1Z0qyg_MTu8wVL",
//               section_id: "JuYhS5weVhSEtiyFclPNk",
//               test_types: "AFFIRMATIVE_PASS",
//               description: "N/A",
//             },
//           ],
//           section_id: "JuYhS5weVhSEtiyFclPNk",
//         },
//         {
//           id: "27oMypbMOkyjTEwc125U4",
//           type: "SUB-SECTION",
//           items: [
//             {
//               id: "uCT4uZfxhpNIQGCA9p55V",
//               type: "INSTRUCTION",
//               title: "",
//               content:
//                 "Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more. Example instruction goes here. It could be about safety measures, lab equipment, and more.",
//               infoPanel: "none",
//               section_id: "JuYhS5weVhSEtiyFclPNk",
//             },
//             {
//               id: "Gz00CEhIiVQIcqFnvs1ll",
//               type: "GROUP",
//               items: [
//                 {
//                   id: "BkwTSXlehfNv_gt1ffNxl",
//                   na: false,
//                   skip: false,
//                   type: "PASS/FAIL",
//                   warn: false,
//                   label: "Test",
//                   _group: "Gz00CEhIiVQIcqFnvs1ll",
//                   section_id: "JuYhS5weVhSEtiyFclPNk",
//                   description: "N/A",
//                 },
//               ],
//               section_id: "JuYhS5weVhSEtiyFclPNk",
//             },
//           ],
//           steps: ["uCT4uZfxhpNIQGCA9p55V", "BkwTSXlehfNv_gt1ffNxl"],
//           title: "",
//           section_id: "JuYhS5weVhSEtiyFclPNk",
//         },
//       ],
//       steps: [
//         "LnjMrnxqp47pJBEvO45mn",
//         "J6CVkGW7V4AEOgewgsIus",
//         "g-faH7hlg6oYz2rwjKr8l",
//         "e5HY-nJhGJRRqxW-w5oou",
//         "np9-J0il747pHeXalMloz",
//         "Ph5S2um3tV9iX36QqCqaZ",
//         "DQwTwO0sFtp34-EozEjTY",
//         "4VVd_nlYvXBIGuNI-TLsS",
//         "oNy3aMym_ORgjqe4f6PHI",
//         "27oMypbMOkyjTEwc125U4",
//       ],
//       title: "Section Title Four",
//     },
//   ],
// };

export const processProcedure = (procedure) => {
  //   let procedure = attributes;
  let newProcedureItems = Array.from(procedure["items"]).map(
    (section, sectionIndex) => {
      const sectionNumber = String(sectionIndex + 1);
      let groupNumber = 0;
      return {
        ...section,
        number: sectionNumber,
        items: Array.from(section["items"]).map((group, groupIndex) => {
          if (group.type === "SUB-SECTION") {
            const subSectionStep = `${sectionNumber}.${getStep(
              group.id,
              section
            )}`;
            let subSectionGroupNumber = 0;
            return {
              // Subsection
              ...group,
              number: subSectionStep,
              items: group["items"]?.map(
                (subSectionGroup, subSectionGroupIndex) => {
                  if (subSectionGroup.type !== "GROUP") {
                    return {
                      ...subSectionGroup,
                      number: `${getStep(
                        subSectionGroup.id,
                        section,
                        group.id,
                        subSectionStep
                      )}`,
                    };
                  } else {
                    subSectionGroupNumber += 1;
                    return {
                      ...subSectionGroup,
                      number: String(subSectionGroupNumber),
                      section_number: sectionNumber,
                      sub_section_number: subSectionStep,
                      items: Array.from(subSectionGroup["items"]).map(
                        (subSectionGroupItem, subSectionGroupItemIndex) => {
                          return {
                            ...subSectionGroupItem,
                            group_number: String(subSectionGroupNumber),
                            section_number: sectionNumber,
                            sub_section_number: subSectionStep,
                            number: `${getStep(
                              subSectionGroupItem.id,
                              section,
                              group.id,
                              subSectionStep
                            )}`,
                          };
                        }
                      ),
                    };
                  }
                }
              ),
            };
          }
          if (group.type !== "GROUP") {
            return {
              ...group,
              number: `${sectionNumber}.${getStep(group.id, section)}`,
            };
          } else {
            groupNumber += 1;
            return {
              ...group,
              number: String(groupNumber),
              section_number: sectionNumber,
              items: group["items"].map((groupItem, groupItemIndex) => {
                return {
                  ...groupItem,
                  section_number: sectionNumber,
                  group_number: String(groupNumber),
                  number: `${sectionNumber}.${getStep(groupItem.id, section)}`,
                };
              }),
            };
          }
        }),
      };
    }
  );
  //   console.log("newProcedure", { ...procedure, items: newProcedureItems });
  return { ...procedure, items: newProcedureItems };
};
